import { g as d } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as h } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const u = {
  name: "DtIconNetwork",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], v = ["id"];
function f(e, t, l, p, _, i) {
  return n(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--network"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Network",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 1a.5.5 0 0 1 .5-.5h3A.5.5 0 0 1 8 1v3a.5.5 0 0 1-.5.5h-1v1h3a.5.5 0 0 1 .5.5v1.5h1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h1v-1H3v1h1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h1V6a.5.5 0 0 1 .5-.5h3v-1h-1A.5.5 0 0 1 4 4V1Zm1 2.5v-2h2v2H5Zm3.5 7v-2h2v2h-2Zm-7 0v-2h2v2h-2Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, v)
    ])
  ], 10, c);
}
const q = /* @__PURE__ */ h(u, [["render", f]]);
export {
  q as default
};
//# sourceMappingURL=network.js.map
